import { ApiConfig } from "../../../../config"
import { FetchRequestActions } from "../../../../utils/request-actions-helpers/createRequestActions"
import { UserProfile } from "../../../../models/UserProfile"
import { createRequestActionTypes } from "../../../../utils/request-actions-helpers/createRequestActionTypes"
import { RequestThunkParameters, createRequestThunk } from "../../../../utils/request-actions-helpers/createRequestThunk"

export type UsersAction = FetchRequestActions<UserProfile[]>

export const fetchUsersActionTypes = createRequestActionTypes("USERS")

export const fetchAllUsers = (config: ApiConfig) => {
    const thunkParams: RequestThunkParameters<UserProfile> = {
        method: 'GET',
        requestActionTypes: fetchUsersActionTypes,
        url: `${config.API_URL}/users`
    }
    return createRequestThunk(thunkParams)
}